import React from "react"
import { css } from "@emotion/core"

import * as mixins from "../../../utils/mixins"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { maintenancePageMetadata } from "../../../utils/seo"

import TopDisplayImageCont from "../../components/imageComponents/TopDisplayImageCont"
import TopImage from "../../components/imageComponents/optimized/hydroseeding"
import { HydroseedingTopImageTitle } from "../../components/layoutComponents/top-image-title"

import MaintenanceTwoImg from "../../components/imageComponents/maintenance/MaintenanceTwo"

import * as TextComponent from "../../components/textComponents"
import * as LayoutComponent from "../../components/layoutComponents"
import * as InteractiveComponent from "../../components/interactiveComponents"

import {
  HeaderNavBar,
  HeaderNavBarBackLink,
} from "../../components/layoutComponents/header-nav-bar"

export default function HydroseedingPage() {
  return (
    <Layout>
      <SEO
        title="Landscaping Maintenance"
        description="Landscaping Maintenance in Marin County. Ponderosa Ventures Ltd."
        meta={maintenancePageMetadata}
      />
      <HeaderNavBar>
        <HeaderNavBarBackLink to="/">BACK TO SERVICES</HeaderNavBarBackLink>
      </HeaderNavBar>
      <TopDisplayImageCont>
        <HydroseedingTopImageTitle />
        <TopImage />
      </TopDisplayImageCont>

      <LayoutComponent.SectionContainer
        styles={css`
          ${mixins.device.mobileX} {
            padding-bottom: 0.15rem;
          }
        `}
      >
        <TextComponent.BodyText>
          Landscaping isn&apos;t cheap. Protect your investment with quality
          maintenance services.
        </TextComponent.BodyText>

        <TextComponent.BodyText>
          Ponderosa offers follow-up maintenance services for every type of
          landscaping job. Our service plans provide you with follow-up care
          that keeps your home/site looking great all year round.
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <LayoutComponent.SectionTitleBanner
        styles={css`
          font-size: 1.175rem;

          ${mixins.device.mobileM} {
            font-size: 1.3rem;
          }
        `}
      >
        MAINTENANCE SERVICES
      </LayoutComponent.SectionTitleBanner>

      <LayoutComponent.SectionContainer
        styles={css`
          padding-bottom: 0;

          ${mixins.device.tablet} {
            padding-bottom: 0;
          }
        `}
      >
        <TextComponent.BodyText
          styles={css`
            margin-bottom: 1rem;
          `}
        >
          We are proud to offer you the following services:
        </TextComponent.BodyText>

        <TextComponent.TreeListItem>
          Lawn Mowing and Care
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Tree Trimming and Pruning
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Dirt and Gravel Movement
        </TextComponent.TreeListItem>

        <TextComponent.TreeListItem>
          Concrete and Paving Stone Cleaning
        </TextComponent.TreeListItem>

        <TextComponent.BodyText>
          With our maintenance plans and services, we can guarantee your site
          looks as good as the day the landscaping work was finished.
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <div
        css={css`
          width: 100%;
          max-height: 12rem;

          ${mixins.device.mobileL} {
            max-height: 16rem;
          }

          ${mixins.device.tablet} {
            max-height: 20rem;
          }
        `}
      >
        <MaintenanceTwoImg />
      </div>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            margin: 1.5rem 0;

            ${mixins.device.mobileX} {
              margin: 1.25rem 0;
            }

            ${mixins.device.tablet} {
              margin: 2.25rem 0 1.25rem;
            }
          `}
        >
          <TextComponent.BodyBold>Have questions?</TextComponent.BodyBold> Get
          in touch, we’d love to find out how we can save you time and money on
          your project.
        </TextComponent.BodyText>

        <InteractiveComponent.Button to="/contact-us/">
          CONTACT US
        </InteractiveComponent.Button>
      </LayoutComponent.SectionContainer>
    </Layout>
  )
}

function ProductsContainer() {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 2rem 0 1.5rem;

        ${mixins.device.mobileM} {
          margin: 2rem 0 1.5rem;
        }

        ${mixins.device.mobileX} {
          justify-content: space-between;
          padding: 0 1.25rem;
        }

        ${mixins.device.tablet} {
          justify-content: space-around;
          padding: 0;
          margin: 2.5rem 0 2rem;
        }
      `}
    >
      <ProductItem>
        <FlexterraImg />
      </ProductItem>
      <ProductItem>
        <PromatrixImg />
      </ProductItem>
      <ProductItem>
        <TerrawoodImg />
      </ProductItem>
    </div>
  )
}

function ProductItem({ children }) {
  return (
    <div
      css={css`
        width: 28%;
        max-height: 8rem;

        ${mixins.device.mobileM} {
          max-height: 12rem;
          width: 27%;
        }

        ${mixins.device.mobileL} {
          width: 25%;
        }

        ${mixins.device.mobileX} {
          width: 22%;
          max-height: 14rem;
        }

        ${mixins.device.tablet} {
          width: 8rem;
        }
      `}
    >
      {children}
    </div>
  )
}
